module.exports = __webpack_public_path__ + "img/fourth-onboarding-1.25facd5a.png";